import React from "react";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Button from "@material-ui/core/Button";

import withStyles from "@material-ui/core/styles/withStyles";

const styles = {
  root: {
    width: "100%"
  },
  button: {
    textTransform: "none"
  }
};

const SearchResult = props => {
  const { classes } = props;
  return (
    <List className={classes.root}>
      {props.filteredResults.map((element, index) => (
        <Button
          key={"searchResult" + index}
          onClick={() => props.selectArea(element)}
          fullWidth
          disabled={element.v === 0 ? true : false}
          className={classes.button}
        >
          <ListItem>
            <ListItemText primary={element.a} secondary={element.c} />
          </ListItem>
        </Button>
      ))}
    </List>
  );
};

export default withStyles(styles)(SearchResult);
